import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  // Paper,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  Container,
  Grid,
  Alert,
  CircularProgress,
  Fade,
  Card,
  CardContent,
  // useTheme,
  // alpha,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Email,
  Lock,
  ArrowForward,
  Login as LoginIcon,
  Security,
  VpnKey,
} from "@mui/icons-material";
import { connect } from "react-redux";
import {
  showLoadingScreen,
  setSnackBar,
  resetSnackBar,
} from "../reusable_components/site_data/siteDataSlice";
import { backend_url } from "../App";
import axios from "axios";

class Login extends React.Component {
  state = {
    data: {
      login: "",
      password: "",
    },
    errors: {},
    showPassword: false,
    isLoading: false,
    loginError: "",
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: "",
      },
      loginError: "",
    }));
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  validateForm = () => {
    const { login, password } = this.state.data;
    const errors = {};

    if (!login.trim()) {
      errors.login = "Username or email is required";
    } else if (login.trim().length < 3) {
      errors.login = "Must be at least 3 characters";
    }

    if (!password) {
      errors.password = "Password is required";
    } else if (password.length < 8) {
      errors.password = "Must be at least 8 characters";
    }

    this.setState({ errors });
    return Object.keys(errors).length > 0;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (this.validateForm()) {
      return;
    }

    this.setState({ isLoading: true, loginError: "" });
    this.props.showLoadingScreen(true);

    try {
      const response = await axios.post(
        `${backend_url}/accounts/api/auth/login/`,
        {
          login: this.state.data.login.trim(),
          password: this.state.data.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const { auth_token, user: userData } = response.data;

      // Store auth data
      localStorage.setItem("token", auth_token);
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("user_role", userData.user_type);
      localStorage.setItem("user_id", userData.id);

      // Store additional user info for easy access
      localStorage.setItem(
        "user_organization",
        userData.organization ? JSON.stringify(userData.organization) : "",
      );
      localStorage.setItem("username", userData.username);
      localStorage.setItem("email", userData.email);
      localStorage.setItem("first_name", userData.first_name || "");
      localStorage.setItem("last_name", userData.last_name || "");

      const { state } = this.props.location || {};
      if (state && state.from) {
        window.location = state.from.pathname;
      } else {
        window.location = "/home";
      }
    } catch (err) {
      // ... error handling remains the same
    } finally {
      this.setState({ isLoading: false });
      this.props.showLoadingScreen(false);
    }
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit(e);
    }
  };

  render() {
    const { login, password } = this.state.data;
    const { errors, showPassword, isLoading, loginError } = this.state;

    return (
      <Box
        sx={{
          minHeight: "100vh",
          background:
            "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)",
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            width: "200%",
            height: "200%",
            top: "-50%",
            left: "-50%",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)",
            backgroundSize: "50px 50px",
            animation: "float 20s infinite linear",
            zIndex: 0,
          },
          "@keyframes float": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
          },
        }}
      >
        {/* Animated background elements */}
        <Box
          sx={{
            position: "absolute",
            width: "300px",
            height: "300px",
            borderRadius: "50%",
            background:
              "linear-gradient(45deg, rgba(255,255,255,0.1), transparent)",
            top: "10%",
            left: "10%",
            animation: "pulse 4s infinite alternate",
            "@keyframes pulse": {
              "0%": { transform: "scale(1)", opacity: 0.5 },
              "100%": { transform: "scale(1.2)", opacity: 0.8 },
            },
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background:
              "linear-gradient(45deg, transparent, rgba(255,255,255,0.1))",
            bottom: "10%",
            right: "10%",
            animation: "pulse 3s infinite alternate-reverse",
          }}
        />

        <Container maxWidth="lg">
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: "100vh", position: "relative", zIndex: 1 }}
          >
            <Grid item xs={12} md={6} lg={5}>
              <Fade in timeout={800}>
                <Card
                  elevation={24}
                  sx={{
                    borderRadius: 4,
                    background: "rgba(255, 255, 255, 0.95)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    overflow: "hidden",
                    position: "relative",
                    transformStyle: "preserve-3d",
                    perspective: "1000px",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: "6px",
                      background:
                        "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)",
                      backgroundSize: "200% 100%",
                      animation: "gradientShift 3s infinite linear",
                      "@keyframes gradientShift": {
                        "0%": { backgroundPosition: "200% 0" },
                        "100%": { backgroundPosition: "-200% 0" },
                      },
                    },
                  }}
                >
                  <CardContent sx={{ p: 5 }}>
                    {/* Header Section with Logos */}
                    <Box sx={{ textAlign: "center", mb: 4 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 4,
                          mb: 3,
                        }}
                      >
                        <Box
                          sx={{
                            width: 100,
                            height: 100,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background:
                              "linear-gradient(135deg, #fff 0%, #f5f5f5 100%)",
                            borderRadius: 3,
                            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                            transform: "rotateY(10deg)",
                            transition: "transform 0.3s ease",
                            "&:hover": {
                              transform: "rotateY(0deg) scale(1.05)",
                            },
                          }}
                        >
                          <img
                            src={require("../images/wwf_logo.png")}
                            alt="WWF Logo"
                            style={{ width: "80%", height: "auto" }}
                          />
                        </Box>
                        <Box
                          sx={{
                            width: 100,
                            height: 100,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background:
                              "linear-gradient(135deg, #fff 0%, #f5f5f5 100%)",
                            borderRadius: 3,
                            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                            transform: "rotateY(-10deg)",
                            transition: "transform 0.3s ease",
                            "&:hover": {
                              transform: "rotateY(0deg) scale(1.05)",
                            },
                          }}
                        >
                          <img
                            src={require("../images/LUMS.png")}
                            alt="LUMS Logo"
                            style={{ width: "90%", height: "auto" }}
                          />
                        </Box>
                      </Box>

                      <Typography
                        variant="h3"
                        sx={{
                          fontWeight: 700,
                          background:
                            "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)",
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                          mb: 1,
                        }}
                      >
                        Early Warning System
                      </Typography>

                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        sx={{ mb: 4 }}
                      >
                        Wildlife Conservation & Camera Trap Monitoring Platform
                      </Typography>
                    </Box>

                    {/* Login Form */}
                    <Box
                      component="form"
                      onSubmit={this.handleSubmit}
                      noValidate
                    >
                      {loginError && (
                        <Alert
                          severity="error"
                          sx={{
                            mb: 3,
                            borderRadius: 2,
                            animation: "shake 0.5s",
                            "@keyframes shake": {
                              "0%, 100%": { transform: "translateX(0)" },
                              "10%, 30%, 50%, 70%, 90%": {
                                transform: "translateX(-5px)",
                              },
                              "20%, 40%, 60%, 80%": {
                                transform: "translateX(5px)",
                              },
                            },
                          }}
                        >
                          {loginError}
                        </Alert>
                      )}

                      {/* Username/Email Field */}
                      <TextField
                        fullWidth
                        name="login"
                        label="Username or Email"
                        value={login}
                        onChange={this.handleChange}
                        onKeyPress={this.handleKeyPress}
                        error={!!errors.login}
                        helperText={errors.login}
                        disabled={isLoading}
                        sx={{
                          mb: 3,
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                            transition: "all 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                            },
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Email color="action" />
                            </InputAdornment>
                          ),
                        }}
                      />

                      {/* Password Field */}
                      <TextField
                        fullWidth
                        name="password"
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={this.handleChange}
                        onKeyPress={this.handleKeyPress}
                        error={!!errors.password}
                        helperText={errors.password}
                        disabled={isLoading}
                        sx={{
                          mb: 2,
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                            transition: "all 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                            },
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Lock color="action" />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={this.togglePasswordVisibility}
                                edge="end"
                                disabled={isLoading}
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />

                      {/* Forgot Password Link */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          mb: 4,
                        }}
                      >
                        <Link
                          to="/reset-password"
                          style={{ textDecoration: "none" }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              color: "primary.main",
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              "&:hover": {
                                color: "primary.dark",
                                textDecoration: "underline",
                              },
                            }}
                          >
                            <VpnKey fontSize="small" />
                            Forgot your password?
                          </Typography>
                        </Link>
                      </Box>

                      {/* Submit Button */}
                      <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        onClick={this.handleSubmit}
                        disabled={isLoading}
                        sx={{
                          py: 2,
                          borderRadius: 2,
                          background:
                            "linear-gradient(135deg, #454545 0%, rgba(129, 129, 129, 0.95) 100%)",
                          boxShadow: "0 8px 32px rgba(33, 34, 33, 0.66)",
                          position: "relative",
                          overflow: "hidden",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-3px)",
                            boxShadow: "0 12px 40px rgba(0, 0, 0, 0.55)",
                            "&::before": {
                              left: "100%",
                            },
                          },
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: "-100%",
                            width: "100%",
                            height: "100%",
                            background:
                              "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
                            transition: "left 0.5s ease",
                          },
                        }}
                      >
                        {isLoading ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                            }}
                          >
                            <LoginIcon />
                            <Typography variant="button">
                              SIGN IN TO DASHBOARD
                            </Typography>
                            <ArrowForward />
                          </Box>
                        )}
                      </Button>

                      {/* Security Note */}
                      <Box sx={{ mt: 4, textAlign: "center" }}>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 1,
                            opacity: 0.7,
                          }}
                        >
                          <Security fontSize="small" />
                          Your credentials are securely encrypted
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Fade>
            </Grid>

            {/* Right Side - Feature Showcase */}
            <Grid item xs={12} md={6} lg={5} sx={{ pl: { md: 6 } }}>
              <Fade in timeout={1000}>
                <Box
                  sx={{
                    color: "white",
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 800,
                      mb: 2,
                      textShadow: "0 4px 20px rgba(0,0,0,0.3)",
                      background:
                        "linear-gradient(90deg, #fff 0%, #e0e0e0 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Protect Wildlife, Monitor Smartly
                  </Typography>

                  <Typography
                    variant="h5"
                    sx={{
                      mb: 2,
                      opacity: 0.9,
                      textShadow: "0 2px 10px rgba(0,0,0,0.2)",
                    }}
                  >
                    Advanced camera trap monitoring system for leopard
                    conservation
                  </Typography>

                  {/* Features List */}
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 3 }}
                  >
                    {[
                      {
                        icon: "📊",
                        title: "Real-time Analytics",
                        description:
                          "Live monitoring and instant detection alerts",
                      },
                      {
                        icon: "🌍",
                        title: "Global Conservation",
                        description:
                          "Supporting WWF's global wildlife protection initiatives",
                      },
                      {
                        icon: "🔒",
                        title: "Secure Access",
                        description:
                          "Enterprise-grade security for sensitive data",
                      },
                      {
                        icon: "📈",
                        title: "Advanced Reporting",
                        description:
                          "Comprehensive insights and trend analysis",
                      },
                    ].map((feature, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          background: "rgba(255,255,255,0.1)",
                          backdropFilter: "blur(10px)",
                          borderRadius: 2,
                          p: 2,
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateX(10px)",
                            background: "rgba(255,255,255,0.2)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: "2rem",
                            animation: `float ${3 + index}s infinite ease-in-out`,
                            "@keyframes float": {
                              "0%, 100%": { transform: "translateY(0)" },
                              "50%": { transform: "translateY(-10px)" },
                            },
                          }}
                        >
                          {feature.icon}
                        </Box>
                        <Box>
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {feature.title}
                          </Typography>
                          <Typography variant="body2" sx={{ opacity: 0.8 }}>
                            {feature.description}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Fade>
            </Grid>
          </Grid>

          {/* Footer */}
          <Box
            sx={{
              position: "absolute",
              bottom: 20,
              left: 0,
              right: 0,
              textAlign: "center",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "rgba(255,255,255,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <span>
                © {new Date().getFullYear()} WWF-LUMS Conservation Initiative
              </span>
              <span>•</span>
              <Link
                to="#"
                style={{
                  color: "inherit",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Terms of Service
              </Link>
              <span>•</span>
              <Link
                to="#"
                style={{
                  color: "inherit",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Privacy Policy
              </Link>
              <span>•</span>
              <span>v2.0.1</span>
            </Typography>
          </Box>
        </Container>
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  loginStatus: state.site_data,
});

export default connect(mapStateToProps, {
  showLoadingScreen,
  setSnackBar,
  resetSnackBar,
})(Login);
